import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';
import Immutable from 'immutable';
import { CARGO_OPERATIONS } from '../../../../../config/constants';

const AddCargoToItineraryByQrButtonForm = ({
  items,
  onClickAddItemToItinerary,
  setShowModal,
  cargoOperation,
  onClickClose,
  totalItems,
}) => {
  const counter = items ? items.length : 0;

  const onClickConfirm = () => {
    if (cargoOperation.value === CARGO_OPERATIONS.ADD_ITEM.value) {
      onClickAddItemToItinerary(items);
      setShowModal(false);
    }
    if (cargoOperation.value === CARGO_OPERATIONS.UNLOAD_ITEM.value) {
      const allItemsToUnload = totalItems.every((totalItem) =>
        items.some((item) => item.correlation === totalItem.correlation),
      );
      if (allItemsToUnload) setShowModal(false);
      const itemsToUnloadCorrelations = items.map((item) => item.correlation);
      onClickAddItemToItinerary({
        itemsToUnloadCorrelations,
      });
    }
  };

  return (
    <div className="mt-2 pull-right">
      <Button color="secondary" onClick={onClickClose} className="mr-2">
        Cancelar
      </Button>
      <Button color="success" onClick={onClickConfirm} disabled={counter === 0}>
        {cargoOperation.labelDinamic(counter)}
      </Button>
    </div>
  );
};

AddCargoToItineraryByQrButtonForm.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      correlation: PropTypes.string,
      description: PropTypes.string,
      weight: PropTypes.number,
    }),
  ).isRequired,
  onClickAddItemToItinerary: PropTypes.func.isRequired,
  setShowModal: PropTypes.func.isRequired,
  cargoOperation: PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    labelDinamic: PropTypes.func.isRequired,
    color: PropTypes.string.isRequired,
  }).isRequired,
  onClickClose: PropTypes.func.isRequired,
  totalItems: PropTypes.instanceOf(Immutable.List),
};

AddCargoToItineraryByQrButtonForm.defaultProps = {
  totalItems: Immutable.List(),
};

export default AddCargoToItineraryByQrButtonForm;
